import React from "react";
import { ArrowRightIcon, CheckIcon } from "../Icons";
import { useLeadForm } from "../lead-form/LeadFormProvider";
import { CONTAINER, PrimaryButton, SecondaryLink, jumpTo } from "../ui";
import ProductShot from "./ProductShot";
import { SHOTS } from "./shots";

export default function PlatformHero() {
  const openLeadForm = useLeadForm();

  return (
    <section className="tw-bg-[#f4f8fc] tw-pb-14 tw-pt-24 sm:tw-pb-12 sm:tw-pt-12">
      <div
        className={`${CONTAINER} tw-grid tw-grid-cols-[1fr_1.05fr] tw-items-center tw-gap-14 sm:tw-grid-cols-1 sm:tw-gap-12`}
      >
        <div className="tw-min-w-0">
          <p className="tw-m-0 tw-text-xs tw-font-black tw-uppercase tw-tracking-[.15em] tw-text-[#087bd3]">
            The FutureLab platform
          </p>
          <h1 className="tw-mt-5 tw-mb-0 tw-text-[clamp(2.5rem,4.4vw,3.75rem)] tw-font-black tw-leading-[1.03] tw-tracking-[-.045em] tw-text-[#10233f] sm:tw-text-[clamp(2rem,7vw,2.5rem)]">
            One platform for the complete mentoring and coaching journey.
          </h1>
          <p className="tw-mt-6 tw-mb-0 tw-max-w-xl tw-text-lg tw-leading-8 tw-text-[#536a82]">
            Design the journey, match the right mentors, manage every session and show stakeholders
            what changed, without stitching the programme together across spreadsheets and
            separate tools.
          </p>

          <div className="tw-mt-8 tw-flex tw-flex-row tw-items-center tw-gap-3 sm:tw-flex-col sm:tw-items-stretch">
            <PrimaryButton
              type="button"
              size="lg"
              onClick={() => openLeadForm({ enquiryType: "platform_demo" })}
            >
              Book a platform demo
              <ArrowRightIcon aria-hidden className="tw-h-4 tw-w-4 tw-shrink-0" />
            </PrimaryButton>
            <SecondaryLink href="#capabilities" onClick={jumpTo("capabilities")}>
              Explore capabilities
            </SecondaryLink>
          </div>

          <p className="tw-mt-6 tw-mb-0 tw-flex tw-items-start tw-gap-2 tw-text-sm tw-leading-6 tw-text-[#5b7188]">
            <CheckIcon aria-hidden className="tw-mt-1 tw-h-4 tw-w-4 tw-shrink-0 tw-text-[#16a784]" />
            Use your own mentor pool, FutureLab mentors, or a combination of both.
          </p>
        </div>

        <div className="tw-mx-auto tw-w-full tw-max-w-[620px] lg:tw-ml-auto">
          <ProductShot shot={SHOTS.programmeSetup} priority />
        </div>
      </div>
    </section>
  );
}
